import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { updateMessageSessionStatus, updateMessageSessionNotification } from '../../../state/message/messageSessionSlice';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* updateMessageSessionStatusSaga(action) {
    const { messageSessionId, status } = action.payload;
    try {
        const { domain, user } = yield select(selectUserCredentials);

        const params = new URLSearchParams({
            object: 'messagesession',
            action: 'update',
            domain: domain,
            user: user,
            session_id: messageSessionId,
            last_status: status
        }).toString();

        const response = yield call(cirrusClient.post, '/', params, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        yield put(updateMessageSessionStatus({ messageSessionId, status }));
    } catch (error) {
        console.error('Error updating message session status', error);
    }
}

export function* updateMessageSessionNotificationSaga(action) {
    const { messageSessionId, muted } = action.payload;
    try {
        const { domain, user } = yield select(selectUserCredentials);

        const params = new URLSearchParams({
            object: 'messagesession',
            action: 'update',
            domain: domain,
            user: user,
            session_id: messageSessionId,
            muted: muted ? 'yes' : 'no'
        }).toString();

        const response = yield call(cirrusClient.post, '/', params, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (response.status === 202) {
            yield put(updateMessageSessionNotification({ messageSessionId, muted }));

            yield put(showSnackbar({
                message: muted ? 'Notifications muted successfully' : 'Notifications unmuted successfully',
                severity: 'success'
            }));
        }


    } catch (error) {
        console.error('Error updating message session mute status', error);
        yield put(showSnackbar({
            message: muted
                ? 'Failed to mute notifications. Please try again.'
                : 'Failed to unmute notifications. Please try again.',
            severity: 'error'
        }));
    }
}